import { useState, useCallback } from 'react';
import { validateCertificationGroups } from '../utils/certificationValidation';
import { useWizardStepNavigation } from 'modules/views/shared/Wizard';

interface UseSubmissionProps {
  certificationGroups: any[];
  allCertifications: any[];
  isArchivedProject?: boolean;
}

export const useSubmission = ({ certificationGroups, allCertifications, isArchivedProject }: UseSubmissionProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [isViewMoreMode, setIsViewMoreMode] = useState(false);
  const { goToNextStep } = useWizardStepNavigation();

  const getRequiredGroups = useCallback(() => {
    return validateCertificationGroups(certificationGroups || [], allCertifications || []);
  }, [certificationGroups, allCertifications]);

  const hasRequiredCertifications = useCallback(() => {
    return getRequiredGroups().length === 0;
  }, [getRequiredGroups]);

  const handleSubmit = useCallback(async () => {
    // Show warning modal if there are missing certifications
    if (!isArchivedProject && !hasRequiredCertifications()) {
      setIsViewMoreMode(false);
      setShowWarningModal(true);
      return;
    }
    // Otherwise, proceed to next step
    goToNextStep();
  }, [isArchivedProject, hasRequiredCertifications, goToNextStep]);

  const handleOpenWarningModal = useCallback(() => {
    setIsViewMoreMode(true);
    setShowWarningModal(true);
  }, []);

  const handleWarningModalClose = useCallback(() => {
    setShowWarningModal(false);
  }, []);

  const handleProceedAnyway = useCallback(async () => {
    setShowWarningModal(false);
    goToNextStep();
  }, [goToNextStep]);

  return {
    isSubmitting,
    showWarningModal,
    isViewMoreMode,
    handleSubmit,
    handleOpenWarningModal,
    handleWarningModalClose,
    handleProceedAnyway,
    setIsSubmitting,
    getRequiredGroups,
    hasRequiredCertifications,
  };
};
